import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { AbstractHypeService } from '../../services/abstract-hype.service';
import { Subscription } from 'rxjs';
import { HypeModel } from '../../models/hype.model';
import { Debounce } from 'lodash-decorators';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { APP_BASE_HREF } from '@angular/common';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';

export enum HypeTabTypeEnum {
    primary = 'primary',
    secondary = 'secondary'
}

@Component({
    selector: 'agpr-hype',
    templateUrl: './hype.component.html',
    styleUrls: ['./hype.component.scss'],
    standalone: false
})
export class HypeComponent implements OnInit, OnDestroy {

    config: HypeModel;
    buttonTypes = ButtonTypesEnum;

    imgUrl: string;
    showImage: boolean = false;

    naturalLanguageBannerTitle: string = '';
    hasAgentDebug: boolean = false;
    naturalLanguagePrompt: string = '';
    taskDescription: string = '';
    systemPrompt: string = '';
    topicSystemPrompt: string = '';

    // Tab toggle state (used when naturalLanguage + secondaryHeadingText are both set)
    selectedTabType: HypeTabTypeEnum = HypeTabTypeEnum.primary;

    readonly id = 'hype';
    readonly messageSeverityEnum = messageSeverityEnum;
    readonly hypeTabTypeEnum = HypeTabTypeEnum;

    private subscriptions: Subscription[] = [];

    constructor(
        public hypeService: AbstractHypeService,
        private configService: ConfigService,
        @Inject(APP_BASE_HREF) public appBaseHref: string,
    ) {
        this.imgUrl = appBaseHref + 'assets/images/hypeImage.png';
    }

    ngOnInit() {
        this.subscriptions.push(
            this.hypeService.getConfig().subscribe(
                (hypeConfig) => {
                    this.config = hypeConfig;
                    this.hasAgentDebug = hypeConfig?.hasAgentDebug ?? false;
                }
            )
        );

        this.showImage = !this.configService.hasBrandGUID();
    }

    showContextTakeover(naturalLanguagePrompt: string): void {
        this.hypeService.showContextTakeover?.(naturalLanguagePrompt, (refined) => {
            this.naturalLanguagePrompt = refined;
        });
    }

    @Debounce(300, {leading: false})
    clickLink() {
        this.hypeService.buttonClicked();
    }

    @Debounce(300, {leading: false})
    clickSecondaryLink() {
        this.hypeService.secondaryButtonClicked();
    }

    // Used in Briefings > AI banner to toggle between the two agpr-button components
    onTabToggleKeydown(event: KeyboardEvent): void {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();

            if (this.selectedTabType === this.hypeTabTypeEnum.primary) {
                this.selectedTabType = this.hypeTabTypeEnum.secondary;
            } else {
                this.selectedTabType = this.hypeTabTypeEnum.primary;
            }
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach((value) => {
            value.unsubscribe();
        });
    }
}
